import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgZoomCenter = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "#AAA",
		"data-name": "34-Arrow In",
		children: /* @__PURE__ */ _jsx("path", { d: "M11 9.59 1.71.29.29 1.71 9.59 11H5v2h7a1 1 0 0 0 1-1V5h-2ZM20 13h7v-2h-4.59l9.29-9.29L30.29.29 21 9.59V5h-2v7a1 1 0 0 0 1 1M27 21v-2h-7a1 1 0 0 0-1 1v7h2v-4.59l9.29 9.29 1.41-1.41L22.41 21ZM12 19H5v2h4.59l-9.3 9.29L1.7 31.7l9.3-9.29V27h2v-7a1 1 0 0 0-1-1" })
	})
});
export default SvgZoomCenter;
